

































































































































































import Vue from 'vue'
import _ from 'lodash'
import { TOGGLE_DRAWER, MESSAGING_SET_MENU_STATE } from '@/store/mutation-types'
import CurrentUserProfileHeader from '@/components/current-user/ProfileHeader.vue'
import { CurrentUser } from '@/model/CurrentUser'
import Messaging from '@/components/Messaging.vue'
import {
  MESSAGING_GET_SHOW_MENU,
  MESSAGING_GET_MESSAGES_LIST,
  GET_IS_CAPELO
} from '@/store/getter-types'
import {
  FETCH_EMPLOYEE_PHOTO, FETCH_TOOLS, RUN_TOOLS,
  SET_SHOW_MENU_ADDRESS,
  SET_SHOW_MENU_DISPOSITION,
  SET_SHOW_MENU_PROJECT, SET_SHOW_MENU_TICKETING
} from '@/store/action-types'
import InformationDialog from '@/components/InformationDialog.vue'
import * as securityService from '@/services/security-service'
import { SecurityArea, SecurityComponent } from '@/types/enums'
import WarningDialog from '@/components/WarningDialog.vue'
import { Tools } from '@/model/Tools'
import { GetToolsResponse, RunToolResponse } from '@/types/service-response'
import { SystemMessage } from '@/model/messaging/Message'

interface ComponentData {
  show: boolean
  employeePhoto: string
  showPersonalDisposition: boolean
  disabledPersonalDisposition: boolean
  showInformationDialog: boolean
  showAddressButton: boolean
  disabledAddressButton: boolean
  showMultisiteAddressSearchButton: boolean
  disabledMultisiteAddressSearchButton: boolean
  showProjectButton: boolean
  disabledProjectButton: boolean
  showPrintingActivityButton: boolean
  disabledPrintingActivityButton: boolean
  showToolsButton: boolean
  disabledToolsButton: boolean
  showTicketingButton: boolean
  disabledTicketingButton: boolean
  isAnimation: boolean
  showWarningDialog: boolean
  warningMessage: string
  toolList: Tools[]
  selectedToolCode: string | undefined
  showCockpitButton: boolean
  disabledCockpitButton: boolean
  disabledAbsencesButton: boolean
  disabledReportsButton: boolean
}

export default Vue.extend({
  name: 'AppToolbar',

  components: {
    CurrentUserProfileHeader,
    Messaging,
    InformationDialog,
    WarningDialog
  },

  computed: {
    currentUser (): CurrentUser {
      return this.$store.state.currentUser
    },

    showMessaging (): boolean {
      return this.$store.getters[MESSAGING_GET_SHOW_MENU]
    },

    messagingColor (): string {
      return this.show ? 'primary' : this.$store.getters[MESSAGING_GET_MESSAGES_LIST].length > 0 ? 'primary' : 'secondary'
    },

    menuItems (): Array<any> {
      if(this.$store.state.sidebar) {
        const data: any = this.$store.state.sidebar.children.filter((item: any) => item.route === '/absences' || item.route === '/reporting')
        return data
      } else {
        return []
      }
    },

    menuItemPlanning (): Array<any> {
      if(this.$store.state.sidebar) {
        const data: any = this.$store.state.sidebar.children.filter((item: any) => item.route === '/planning')
        return data
      } else {
        return []
      }
    },

    buttonStyle (): any {
      if(this.$vuetify.breakpoint.xsOnly) {
        return { 'height': '38px', 'width': '38px' }
      }
    },

    getLogo (): string {
      if(this.isCapelo && this.isAnimation) {
        setTimeout(() => {
          this.isAnimation = false
        }, 2600)
        return require('@/assets/capelo_logo_ani_200_60_gray.gif')
      } else if (this.isCapelo && !this.isAnimation) {
        return require('@/assets/capelo_logo_still_200_60_gray.png')
      } else {
        return require('@/assets/SYZpepLogo.png')
      }
    },

    isCapelo (): boolean {
      return this.$store.getters[GET_IS_CAPELO]
    },

    messageBadge (): number {
      const reviewed = this.$store.getters[MESSAGING_GET_MESSAGES_LIST].filter((item: SystemMessage) => !item.reviewed)
      return reviewed.length
    }
  },

  watch:{
    showMessaging (newVal) {
      this.show = newVal
    },

    show (newValue: boolean): void {
      if (_.isBoolean(newValue)) {
        this.$store.commit(MESSAGING_SET_MENU_STATE, newValue)
      }
    }
  },

  methods: {
    toggleDrawer () {
      this.$store.commit(TOGGLE_DRAWER)
    },

    async fetchPhoto (): Promise<void> {
      try {
        this.employeePhoto = await this.$store.dispatch(FETCH_EMPLOYEE_PHOTO, this.$store.state.currentUser.id)
      } catch (e) {
        this.employeePhoto = ''
      }
    },

    onInformationClick (): void {
      this.showInformationDialog = true
    },

    onInformationDialogClose (): void {
      this.showInformationDialog = false
    },

    onCockpitClick (): void {
      this.$router.push('/cockpit')
    },

    onAddressMultisiteClick (): void {
      this.$router.push('/address-search-multisite')
    },

    onAddressClick (): void {
      this.$store.dispatch(SET_SHOW_MENU_ADDRESS, true)
      this.toggleDrawer()
    },

    onProjectClick (): void {
      this.$store.dispatch(SET_SHOW_MENU_PROJECT, true)
      this.toggleDrawer()
    },

    onPrintingActivityClick (): void {
      this.$router.push('/printing-activity')
    },

    onDispositionClick (): void {
      this.$store.dispatch(SET_SHOW_MENU_DISPOSITION, true)
      this.toggleDrawer()
    },

    onToolClick (item: Tools): void {
      this.warningMessage = item.question
      this.showWarningDialog = true
      this.selectedToolCode = item.code ? item.code : undefined
    },

    onTicketingClick (): void {
      this.$store.dispatch(SET_SHOW_MENU_TICKETING, true)
      this.toggleDrawer()
    },

    onWarningDialogClose (): void {
      this.selectedToolCode = undefined
      this.showWarningDialog = false
    },

    async onWarningDialogSave (): Promise<void> {
      if(this.selectedToolCode) {
        try {
          this.$emit('loading', true)
          const response: RunToolResponse = await this.$store.dispatch(RUN_TOOLS, this.selectedToolCode)
          this.$emit('loading', false)
          if (!response.IsError && response.Found) {
            this.selectedToolCode = undefined
            this.showWarningDialog = false
            this.$emit('toolsSuccessSnackbar')
          } else {
            this.$emit('toolsErrorSnackbar')
          }
        } catch {
          this.$emit('loading', false)
          this.$emit('toolsErrorSnackbar')
        }
      }
    },

    async fetchTools (): Promise<void> {
      try {
        const response: GetToolsResponse = await this.$store.dispatch(FETCH_TOOLS)
        if(!response.IsError) {
          this.toolList = Tools.createFromResponse(response.Tools)
        }
      } catch {}
    }
  },

  mounted () {
    this.fetchPhoto()
    this.fetchTools()
    this.showPersonalDisposition = securityService.isVisible(SecurityArea.Menu, SecurityComponent.PersonalDisposition)
    this.disabledPersonalDisposition = securityService.isDisabled(SecurityArea.Menu, SecurityComponent.PersonalDisposition)
    this.showAddressButton = securityService.isVisible(SecurityArea.Masterdata, SecurityComponent.Address)
    this.disabledAddressButton = securityService.isDisabled(SecurityArea.Masterdata, SecurityComponent.Address)
    if(this.isCapelo && securityService.isVisible(SecurityArea.Menu, SecurityComponent.Projects)) {
      this.showProjectButton = true
      this.disabledProjectButton = securityService.isDisabled(SecurityArea.Menu, SecurityComponent.Projects)
    }
    this.showPrintingActivityButton = securityService.isVisible(SecurityArea.Menu, SecurityComponent.PrintingActivity)
    this.disabledPrintingActivityButton =securityService.isDisabled(SecurityArea.Menu, SecurityComponent.PrintingActivity)
    this.showMultisiteAddressSearchButton = securityService.isVisible(SecurityArea.Menu, SecurityComponent.MultisiteAddressSearch)
    this.disabledMultisiteAddressSearchButton = securityService.isDisabled(SecurityArea.Menu, SecurityComponent.MultisiteAddressSearch)
    this.showToolsButton = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Tools)
    this.disabledToolsButton = securityService.isDisabled(SecurityArea.Menu, SecurityComponent.Tools)
    this.showTicketingButton = securityService.isVisible(SecurityArea.Menu, SecurityComponent.TicketSystem)
    this.disabledTicketingButton = securityService.isDisabled(SecurityArea.Menu, SecurityComponent.TicketSystem)
    this.showCockpitButton = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Cockpit)
    this.disabledCockpitButton = securityService.isDisabled(SecurityArea.Menu, SecurityComponent.Cockpit)
    this.disabledAbsencesButton = securityService.isDisabled(SecurityArea.Menu, SecurityComponent.Absences)
    this.disabledReportsButton = securityService.isDisabled(SecurityArea.Menu, SecurityComponent.Reports)
  },

  data (): ComponentData {
    return {
      show: false,
      employeePhoto: '',
      showPersonalDisposition: false,
      disabledPersonalDisposition: false,
      showInformationDialog: false,
      showAddressButton: false,
      disabledAddressButton: false,
      showMultisiteAddressSearchButton: false,
      disabledMultisiteAddressSearchButton: false,
      showProjectButton: false,
      disabledProjectButton: false,
      showPrintingActivityButton: false,
      disabledPrintingActivityButton: false,
      showToolsButton: false,
      disabledToolsButton: false,
      showTicketingButton: false,
      disabledTicketingButton: false,
      isAnimation: true,
      showWarningDialog: false,
      warningMessage: '',
      toolList: [],
      selectedToolCode: undefined,
      showCockpitButton: false,
      disabledCockpitButton: false,
      disabledAbsencesButton: false,
      disabledReportsButton: false,
    }
  }
})
